<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Defining_an_Editor/Styling';
    let nextLink= '/Documentation/Defining_Scope_Rules';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="the-parser-projection-1"
  bind:intersecting={visibleById["the-parser-projection-1"]}
  onIntersectChange={(visible) => setVisible("the-parser-projection-1", visible)}
>The Parser Projection</SectionComponent>
<p>Freon generates a parser (wrapped in a file reader), and un unparser (wrapped in a file writer), both
based on the default projection. Because the unparser must be able to read the files
that were written using the parser, both are based on the same projection.</p>
<p>However, if the default projection is not suitable for reading from or writing to text files,
a separate projection called <code>parser</code> can be used. This projection is never shown in the editor.
Like other projections, the parser generation falls back to the default projection for a certain concept, when
no definition is present in the <code>parser</code> projection set.</p>
<p>Layout elements, such as vertical and horizontal lists, are preserved wherever possible. Furthermore,
typical parse problems like left and right recursion are avoided. To be able to do so,
Freon uses a parser generator called <a href="https://github.com/dhakehurst/net.akehurst.language" target="_blank">AGL</a>,
created by David Akehurst, which is more powerful than most PEG parser generators.</p>
<p>However, it is still possible to create a projection that cannot be parsed. Please consider this
when writing the parser projection.</p>


<PrevNextSection {prevLink} {nextLink} />